import { ActivityCard, Heading } from "@/components";
import useCustomTemplates from "./useCustomTemplates";
import { routes } from "@/routes/utils";
import { FileChartColumn } from "lucide-react";

const CustomTemplates = () => {
  const {breadcrumbData, onBackClick, onCardClick} = useCustomTemplates();

    return (
    <div className="p-4 md:p-6">
        {/* Header & Search */}
        <div className="flex flex-col xl:flex-row gap-2 xl:items-center xl:justify-between mb-6">
          <div className="flex flex-row items-center justify-between">
            <Heading
              title={`Custom Templates`}
              breadcrumbData={breadcrumbData}
              showBack
              onBackClick={onBackClick}
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-[30px]">
            <ActivityCard
                isCreate={false}
                isSummary={false}
                hideCount={true}
                data={{
                    id: "reports",
                    desc: "State Level TnC Template",
                    title: "View Template",
                    icon: FileChartColumn,
                    link: `${routes.stateLevelTnc}`,
                    subtitle: "",
                    subtitleColor: "text-green-600",
                    apiKey: "",
                    hideCount: true,
                  }}
                onCardClick={onCardClick}
            />
        </div>
    </div>
  );
};

export default CustomTemplates;